import * as React from 'react';

import { Pack, assignedStudentsSentence, canManagePack, cappedAssignedCount, completedStudentsSentence, escapeHtml } from './shared';

import { Tooltip, helpIcon } from '../../../../Shared/index';

interface ProgressHelpProps {
  assigned: number;
  completed: number;
  roster: number;
  pack?: Pack;
  classroomName?: string;
  isDiagnostic?: boolean;
}

function completionDefinition(isDiagnostic?: boolean): string {
  const whoCompletedWhat = isDiagnostic
    ? 'students assigned this diagnostic who have completed it'
    : 'students assigned this pack who have completed all of its activities'
  return `<span class="tooltip-lead">The percentage of ${whoCompletedWhat}.</span>`
}

function progressExplanation({ assigned, completed, roster, pack, classroomName, isDiagnostic }: ProgressHelpProps): string {
  const shown = cappedAssignedCount(assigned, roster)
  const assignedSentence = assignedStudentsSentence({ shown, roster, where: classroomName || 'this class', isDiagnostic })
  const explanation = completionDefinition(isDiagnostic) + escapeHtml(`${assignedSentence} ${completedStudentsSentence(Math.min(completed, shown), shown)}`)
  if (!roster || shown === roster || !pack || !canManagePack(pack)) { return explanation }
  return `${explanation}<span class="tooltip-footnote">To assign it to more students, click Edit students.</span>`
}

const ProgressHelp = (props: ProgressHelpProps) => (
  <Tooltip
    isTabbable={false}
    tooltipText={progressExplanation(props)}
    tooltipTriggerText={<button aria-label="About this progress" className="interactive-wrapper focus-on-light" type="button"><img alt="" src={helpIcon.src} /></button>}
  />
)

export default ProgressHelp
